import TagManager from '@sooro-io/react-gtm-module'
import { getUserInfo } from './utils/general'

export const pageView = ({
	path,
	oldHistoryUrl,
	newHistoryUrl,
	user: { isLoggedIn, customer } = {},
	defaultShippingCountry,
} = {}) => {
	TagManager.dataLayer({
		dataLayer: {
			event: 'user_info',
			user_info: getUserInfo({ isLoggedIn, customer, defaultShippingCountry }),
		},
	})
	TagManager.dataLayer({
		dataLayer: {
			event: 'pageview',
			page: {
				path,
				oldHistoryUrl,
				newHistoryUrl,
			},
		},
	})

	return true
}
